import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";
import * as Yup from "yup";

const paymentStatusValidation = Yup.object().shape({
  sortOrder: Yup.number().required("Sort order is required").min(1),
  paymentStatus: Yup.string().required("Payment status is required"),
  isActive: Yup.bool().required(),
});

const AddPaymentStatus = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: {
      sortOrder: editData?.sortOrder || 1,
      paymentStatus: editData?.paymentStatus || "",
      isActive: editData?.isActive ?? false,
    },
    validationSchema: paymentStatusValidation,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(
              `/paymentStatus/updatePaymentStatus/${editingId}`,
              values,
            )
          : await axiosInstance.post(
              "/paymentStatus/createPaymentStatus",
              values,
            );
        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/payment-status");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Payment Status", path: "/payment-status" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Payment Status
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Sort Order */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="sortOrder" className="col-form-label">
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control border-dark"
                        id="sortOrder"
                        name="sortOrder"
                        placeholder="Enter Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Payment Status */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="paymentStatus" className="col-form-label">
                        Payment Status
                      </label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        id="paymentStatus"
                        name="paymentStatus"
                        placeholder="e.g. Paid, Pending, Refunded"
                        value={values.paymentStatus}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.paymentStatus && errors.paymentStatus && (
                        <small className="text-danger">
                          {errors.paymentStatus}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Is Active */}
                  <div className="col-md-6 mt-3">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>
                  <Link to="/payment-status">
                    <Button color="danger mx-2">Cancel</Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPaymentStatus;
